import { createLogger } from '@/lib/logger';
import { MiniCartFooter } from '../elements/mini-cart-footer';
import { Cart } from './core';

export class CheckoutEventChain {
  private eventChain: ((cart: Cart) => Promise<Cart>)[] = [];
  private logger = createLogger('checkout-event-chain');

  public addEvent(event: (cart: Cart) => Promise<Cart>) {
    this.eventChain.push(event);
  }

  public async execute(cart: Cart) {
    this.logger.info(`Executing checkout event chain (${this.eventChain.length} events)`);
    // Run the chain events in series, passing the resulting cart to the next event
    for (const event of this.eventChain) {
      cart = await event(cart);
    }
    return cart;
  }
}

window.addCheckoutEventChain = async function (
  callback: (cart: Cart) => Promise<Cart>,
): Promise<boolean> {
  try {
    const footerElem = document.querySelector<MiniCartFooter>('mini-cart-footer');
    if (!footerElem) return false;

    const checkoutChain = footerElem.checkoutEventChain;

    if (!checkoutChain) return false;

    checkoutChain.addEvent(callback);
    return true;
  } catch (e) {
    console.error(e);
    return false;
  }
};
